import { useMutation, useQueryClient } from "@tanstack/react-query";
import axiosInstance from "../utils/axiosInstance";
import { CART_ITEM_QUERY_KEY, BUY_NOW_ITEM_QUERY_KEY } from "../constants/queryKeys";

const useVerifyCoupon = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (data) => {
      return axiosInstance("/coupons/validate", "POST", {
        code: data.code,
        amount: data.amount,
        shippingCost: data.shippingCost,
        userId: data.userId,
        itemType: data.itemType,
        itemId: data.itemId,
        vendorId: data.vendorId ?? null,
        productId: data.productId ?? null,
        categoryId: data.categoryId ?? null,
        subcategoryId: data.subcategoryId ?? null,
        typeId: data.typeId ?? null,
        cartItems: data.cartItems ?? [],
      });
    },
    onSuccess: (_, variables) => {
      // Invalidate relevant queries based on itemType
      if (variables.itemType === 'cart') {
        queryClient.invalidateQueries({ queryKey: [CART_ITEM_QUERY_KEY] });
      } else if (variables.itemType === 'buynow') {
        queryClient.invalidateQueries({ queryKey: [BUY_NOW_ITEM_QUERY_KEY] });
      }
    }
  });

  return {
    verifyCoupon: mutation.mutate,
    isLoading: mutation.isPending,
    error: mutation.error,
    data: mutation.data?.data,
  };
};

export default useVerifyCoupon;
